import styled, { css as styledCss } from "styled-components";

interface LayoutProps {
  fullWidth?: boolean;
}

export const Layout = styled.div<LayoutProps>`
  font-size: 14px;
  line-height: 26px;
  padding-top: 30px;
  color: var(--section-ebony-light-color, var(--ebony-light));
  margin-bottom: 32px;
  ${({ fullWidth }) =>
    !fullWidth &&
    styledCss`
      max-width: 840px;
    `};
`;
